import React from 'react';
import { Container, Grid, Box } from '@mantine/core';

import InsertDataX from "../../components/dev/apiExecutor/InsertDataX";
import { arrayObjectCategories } from "../../components/dev/api/categories";
import { materialSatuan } from "../../components/dev/api/materialSatuan";
import { materialSupplier } from "../../components/dev/api/materialSupplier";
import { materialSubCategory } from "../../components/dev/api/materialSubCategory";
import { material } from "../../components/dev/api/material";

const DataInsert = () => {

    return (
        <React.Fragment>
            <Container fluid>
                <Grid my={0}>
                    <Grid.Col span={12}>
                        <Box mb='lg'>
                            <InsertDataX
                                stateURL='insert_categories'
                                stateData={arrayObjectCategories}
                                stateButtonCaption='Insert Categories'
                                stateButtonIsDisabled={true}
                            />
                        </Box>

                        <Box mb='lg'>
                            <InsertDataX
                                stateURL='insert_material_unit'
                                stateData={materialSatuan}
                                stateButtonCaption='Insert Material Unit'
                                stateButtonIsDisabled={true}
                            />
                        </Box>

                        <Box mb='lg'>
                            <InsertDataX
                                stateURL='insert_supplier'
                                stateData={materialSupplier}
                                stateButtonCaption='Insert Supplier'
                                stateButtonIsDisabled={true}
                            />
                        </Box>

                        <Box mb='lg'>
                            <InsertDataX
                                stateURL='insert_material_category_sub'
                                stateData={materialSubCategory}
                                stateButtonCaption='Insert Material Category Sub'
                                stateButtonIsDisabled={true}
                            />
                        </Box>

                        <Box mb='lg'>
                            <InsertDataX
                                stateURL='insert_material'
                                stateData={material}
                                stateButtonCaption='Insert Material'
                                stateButtonIsDisabled={true}
                            />
                        </Box>
                    </Grid.Col>
                </Grid>
            </Container>
        </React.Fragment>
    )
}

export default DataInsert;